import script from "./TitleBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleBar.vue?vue&type=script&setup=true&lang=ts"

import "./TitleBar.vue?vue&type=style&index=0&id=89d2d95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d2d95c"]])

export default __exports__